/**
 * Frontend mock LAYER — for capabilities the frozen /api/v1 contract does not
 * expose (portfolio aggregates + compare, cross-site alerts, user/tenant admin,
 * per-client scoping). Seed data only; no backend. Framed to insurers as
 * simulated / roadmap, never shipped capability.
 *
 * NOT here: SCADA — that has a real (mock) backend, consumed via lib/api/operations.ts.
 */
export const MOCKS_SIMULATED = true

export type Trend = 'up' | 'flat' | 'down'
export type FleetRow = {
  id: string
  name: string
  pack: 'BESS' | 'DSEAR'
  /** control confidence 0–100, or null when engine metadata is in progress */
  control: number | null
  trend: Trend
  scada: 'live' | 'stale' | 'none'
  critical?: boolean
  spark: number[]
}

export const FLEET: FleetRow[] = [
  { id: 'SITE-001', name: 'Meridian BESS — Hall 3', pack: 'BESS', control: 51, trend: 'down', scada: 'live', critical: true, spark: [55, 54, 53, 52, 51] },
  { id: 'SITE-002', name: 'Depot B — Battery Hall 1', pack: 'BESS', control: 38, trend: 'down', scada: 'live', critical: true, spark: [46, 44, 41, 39, 38] },
  { id: 'SITE-003', name: 'Hub C — Grid Store', pack: 'BESS', control: 82, trend: 'up', scada: 'live', spark: [76, 78, 79, 81, 82] },
  { id: 'SITE-004', name: 'Riverside — Pack 2', pack: 'BESS', control: 66, trend: 'flat', scada: 'stale', spark: [64, 65, 66, 66, 66] },
  { id: 'SITE-010', name: 'Teesside Aromatics — Unit 4', pack: 'DSEAR', control: null, trend: 'flat', scada: 'none', spark: [] },
]

export type AlertRow = {
  id: string
  kind: 'scada' | 'drift' | 'obligation'
  site: string
  message: string
  severity: 'critical' | 'warning' | 'info'
  ageMins: number
}

export const ALERTS: AlertRow[] = [
  { id: 'AL-1', kind: 'scada', site: 'Meridian BESS — Hall 3', message: 'Rack B cell ΔT crossed threshold', severity: 'critical', ageMins: 12 },
  { id: 'AL-2', kind: 'obligation', site: 'Meridian BESS — Hall 3', message: 'Gas detection calibration overdue', severity: 'warning', ageMins: 180 },
  { id: 'AL-3', kind: 'drift', site: 'Depot B — Battery Hall 1', message: 'Control confidence declining (−7 pts)', severity: 'warning', ageMins: 1440 },
]

export type AdminUser = { id: string; name: string; email: string; role: string; lastActive: string }
export const ADMIN_USERS: AdminUser[] = [
  { id: 'U-1', name: 'J. Meade', email: 'j.meade@expas.tech', role: 'Risk Assessor', lastActive: '2m ago' },
  { id: 'U-2', name: 'A. Okafor', email: 'a.okafor@howden.com', role: 'Underwriter', lastActive: '1h ago' },
  { id: 'U-3', name: 'L. Brandt', email: 'l.brandt@insurer.example', role: 'Insurer / Client', lastActive: '3d ago' },
]
